export const ARCHICAD_UPLOAD_HELP_URL =
  'https://nemetschekprime.atlassian.net/helpcenter/ocp/page/d0d3c522/Open+Collaboration+Platform+Early+Access+Portal';
